import { Role } from '../graphql/generated';

export enum RoleType {
  Admin = 'ROLE_TYPE:ADMIN',
  CentralTeam = 'ROLE_TYPE:CENTRAL_TEAM',
  Customer = 'ROLE_TYPE:CUSTOMER',
  Supplier = 'ROLE_TYPE:SUPPLIER',
}

export type RoleTypes = Record<Role, RoleType>;
